import { ResourceStatus } from '@angular/core';
import { distinctUntilChanged, filter, map, OperatorFunction, pairwise, pipe } from 'rxjs';

export const apiFinishedLoading = (): OperatorFunction<ResourceStatus, ResourceStatus> =>
  pipe(
    pairwise(),
    filter(
      ([prevStatus, currStatus]: [ResourceStatus, ResourceStatus]) =>
        (prevStatus === 'loading' || prevStatus === 'reloading') &&
        (currStatus === 'resolved' || currStatus === 'error'),
    ),
    map(([_prevStatus, currStatus]) => currStatus),
    distinctUntilChanged(),
  );
